import { ProfileImageService } from '@openeducation/oe-it-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';
import { QueryKeys } from '../interfaces/query-keys';

interface UseGetProfileImageProps {
  size: number;
  personId?: number;
}

export const useGetProfileImage = (
  { size, personId }: UseGetProfileImageProps,
  enabled?: boolean
) => {
  const { environment } = useEnvironmentContext();

  const { data, isError, isLoading } = useQuery<string>(
    [QueryKeys.UserProfileImage, personId],
    () => ProfileImageService.fetchImage(environment, size, personId),
    { enabled: enabled && !!size && !!personId }
  );

  return {
    base64Image: data,
    isImageError: isError,
    isImageLoading: isLoading,
  };
};
